import {ActivatedRouteSnapshot} from '@angular/router'

export const getPageTitle = (routeSnapshot: ActivatedRouteSnapshot): string | undefined => {
  let title: string = routeSnapshot.data && routeSnapshot.data.pageTitle ? routeSnapshot.data.pageTitle : ''
  if (routeSnapshot.firstChild) {
    title = getPageTitle(routeSnapshot.firstChild) || title
  }
  return title
}
